export const systemData = {
    clientVersion: '1.2.4'
};
